import styled, { css } from 'styled-components';

import {
    floorGameColor as color,
    styledInteraction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './tokens';

interface GainsArrowProps {
    $loss?: boolean;
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    font-size: ${tokens.text.fontSize}px;
    font-weight: 700;
`;

// TODO: We are temporarily disabling interactions,
// because the <Chip /> component applies interaction
// styling to everything. We either want to:
// 1. Stop using <Chip />.
// 2. Adjust 'Chip > clickable' logic to avoid
//    interaction styling if 'false'.
export const StyledGainsChip = styled.div`
    ${styledReset.borderBox};
    ${styledInteraction.interactionDisable};
`;

export const GainsLabel = styled.div`
    display: flex;
    align-items: center;

    &::after {
        ${typographyBase};
        content: '|';
        margin-left: var(--yat_chip-gap);
        opacity: 0.6;
    }
`;

export const GainsValue = styled.div`
    display: flex;
    align-items: center;
    gap: ${tokens.value.gap}px;
`;

export const GainsText = styled.p`
    ${typographyBase};
    font-variant-numeric: tabular-nums;
`;

export const GainsArrow = styled.div<GainsArrowProps>`
    ${styledMedia.iconWrapper};
    width: ${tokens.icon.size}px;
    height: ${tokens.icon.size}px;
    color: ${({ $loss }) => ($loss ? color.red : color.green)};
    rotate: ${({ $loss }) => ($loss ? '180deg' : undefined)};
`;
